<template>
	<div class="header">
		<div class="h_top">
			<div class="w_1200 fth">
				<div class="fth_text" v-if="$t">{{$t('XYLDFTH')}}</div>
				<div class="language">
					<div class="text">{{$t('XZYY')}}：</div>
					<el-dropdown @command="handleCommand">
						<span class="el-dropdown-link">
							<img :src="activeLanguage.image" class="l_flag" alt="">
							<span class="l_text">{{activeLanguage.title}}</span>
							<span class="iconfont icon-arrow-down"></span>
							<!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item,index) in languageList" :command="index" :key="item.id">
								<img class="icon_flag" :src="item.image" alt="">
								<span class="flag_name">{{item.title}}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

				</div>
			</div>
		</div>

		<div class="h_menu">
			<div class="w_1200 menu">
				<div class="logo_img" @click="goHome()">
					<img src="../assets/images/logo.png" alt="">
				</div>
				<div class="m_item">
					<ul>
						<!-- :class="[active == index?'li_active':'']" -->
						<li v-for="(item,index) in menu" :class="[active == index?'li_active':'']"
							@click="activeItem(index)" @mouseover="over(index)" @mouseleave="leave(index)">
							<span class="text">{{item.title}}</span>
							<span class="iconfont icon-arrow-down" v-if="item.child && item.child.length"></span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="line"></div>
		<div class="children_menu" :class="[show?'show':'']">
			<div class="w_1200 c_box" @mouseleave="childrenLeave()">
				<ul class="c_ul">
					<li v-for="(item,index) in childrenMenu.menu" :key="item.path"
						:class="[childrenActive == index && active == childrenMenu.index?'li_active':'']"
						@click="to(item)">
						<span>{{item.title}}</span>
					</li>
				</ul>
			</div>

		</div>
		<div class="phone">
			<div class="content">
				<div class="logo" @click="goHome()">
					<img src="../assets/images/logo.png" alt="">
				</div>
				<div class="menu_icon" @click="showMenu()">
					<span class="iconfont icon-navlist"></span>
				</div>
			</div>

		</div>

		<div class="menu_mask" v-show="isShowMenu">
			<ul class="menu_ul" v-if="true">
				<li class="menu_li" v-for="(item,index) in menu" :key="item.id">
					<div class="li_con">
						<span class="li_title" @click="pathChange(index)">{{item.title}}</span>
						<div class="placeholder" @click="next(index)"></div>
						<div class="icon_box" @click="getMore(index)">
							<span class="iconfont icon-arrow-right menu_icon"></span>
						</div>
					</div>
					<ul class="child_ul" v-if="item.customIsShow">
						<li class="child_li" v-for="(children,index) in item.child" @click="to(children)">
							<span class="child_li_child">{{children.title}}</span>
							<span class="iconfont icon-arrow-right child_icon"></span>
						</li>
					</ul>
				</li>
			</ul>
			<el-collapse v-if="false" accordion class="el-collapse" v-model="activeNames" @change="handleChange">
				<el-collapse-item :title="item.title" :name="index" v-for="(item,index) in menu">
					<div v-for="(children,index) in item.child" @click="to(children)">
						<span>{{children.title}}</span>
						<span class="iconfont icon-arrow-right"></span>
					</div>
				</el-collapse-item>
			</el-collapse>

		</div>
	</div>
</template>

<script>
	import * as Api from '../service/index.js'
	export default {
		data() {
			return {
				active: -1,
				show: false,
				isShowMenu: false,
				activeNames: [],
				childrenMenu: {
					index: -1,
					menu: []
				},
				languageList: [],
				activeLanguage: '',
				childrenActive: -1,
				menu: []
			}
		},
		created() {
			this.getLang()
			let langInfo = sessionStorage.getItem('activeLanguage')
			if (langInfo) {
				this.activeLanguage = JSON.parse(langInfo)
			}
		},
		methods: {
			activeItem(i) {
				if (this.menu[i].url) {
					this.to(this.menu[i])
				} else if (this.menu[i].child.length > 0) {
					this.show = !this.show
					this.childrenMenu.index = i
					this.childrenMenu.menu = this.menu[i].child
				} else {
					this.show = false
					let path = this.menu[i].url
					this.$router.push(path)
				}
			},
			over(i) {
				if (this.menu[i].child && this.menu[i].child.length > 0) {
					this.show = true
					this.childrenMenu.index = i
					this.childrenMenu.menu = this.menu[i].child
				} else {
					this.show = false
				}
			},
			leave(i) {},
			childrenLeave() {
				this.show = false
			},
			handleChange(e) {
				if (this.menu[e].url) {
					this.to(this.menu[e])
				}
			},
			showMenu() {
				this.isShowMenu = !this.isShowMenu
			},
			to(i) {
				let path = i.url
				this.$router.push({
					path: path,
					query: i
				})
				this.isShowMenu = false
				this.show = false
				this.menu.forEach(item => {
					item.customIsShow = false
				})
				this.$emit('isReload')
			},
			goHome() {
				this.$router.push('/')
			},
			handleCommand(e) {
				this.activeLanguage = this.languageList[e]
				if (this.activeLanguage.id == 1) {
					this.$i18n.locale = 'zh';
				} else if (this.activeLanguage.id == 2) {
					this.$i18n.locale = 'en';
				} else if (this.activeLanguage.id == 6) {
					this.$i18n.locale = 'de';
				} else if (this.activeLanguage.id == 9) {
					this.$i18n.locale = 'es';
				}
				sessionStorage.setItem('language_name',this.$i18n.locale)
				sessionStorage.setItem('language_id', this.languageList[e].id)
				sessionStorage.setItem('activeLanguage', JSON.stringify(this.languageList[e]))
				this.getNav()
				this.$emit('isReload')
			},
			pathChange(i) {
				let info = this.menu[i]
				if (info.customIsShow !== 'undefined') {
					this.to(this.menu[i])
				}
			},
			getMore(i) {
				let info = this.menu[i]
				if (info.customIsShow !== 'undefined') {
					info.customIsShow = !info.customIsShow
				}
				this.menu.splice(i, 1, info)
			},
			next(i) {
				let info = this.menu[i]
				if (info.customIsShow !== 'undefined') {
					this.to(this.menu[i])
				} else {
					this.getMore(i)
				}
			},
			getNav() {
				Api.getNav().then((res) => {
					if (res.code === 200) {
						this.menu = res.data
						this.menu.forEach((item, index) => {
							if (item.child) {
								item.customIsShow = false
								item.child.forEach((e, i) => {
									e.parentUrl = item.url
									e.parentTitle = item.title
								})
							}
						})
						this.watchRouter()
					}
				}).catch(() => {

				})
			},
			getLang() {
				Api.getLang().then((res) => {
					if (res.code === 200) {
						this.languageList = res.data
						if (!this.activeLanguage) {
							this.activeLanguage = this.languageList[0]
						}
						this.getNav()
					}
				}).catch(() => {

				})
			},
			watchRouter() {
				let route = this.$route
				this.menu.forEach((item, index) => {
					if (route.path == '/') {
						this.active = 0
						this.childrenMenu.index = -1
						this.childrenActive = -1
					}
					if (route.path == item.url) {
						this.active = index
						this.childrenMenu.index = -1
						this.childrenActive = -1
					}
					if (item.url && route.path.includes(item.url)) {
						this.active = index
					}
					if (route.query.title == item.title) {
						this.active = index
					}
					if (item.child && item.child.length) {
						item.child.forEach((it, i) => {
							if ((route.path == it.url && route.query.title == it.title)) {
								this.childrenActive = i
								this.active = index
							}
						})
					}

				})
			}
		},
		watch: {
			$route(newV, oldV) {
				this.watchRouter()
			}
		}
	}
</script>

<style lang="less" scoped>
	.header {
		background-color: #fff;
		// overflow-y: scroll;
		// position: sticky;
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		z-index: 999;

		.h_top {
			width: 100%;
			background-color: #F2F3F5;
		}

		.fth {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 36px;

			// padding: 10px 0;

			.fth_text {
				font-size: 12px;
				color: #909399;
			}

			.language {
				display: flex;
				align-items: center;
				font-size: 12px;
				margin-left: 10x;


				.el-dropdown-link {
					display: flex;
					align-items: center;

					.l_flag {
						width: 22px;
						height: 14px;
					}

					.l_text {
						margin: 0 2px 0 8px;
					}
				}

				.el-dropdown-menu {
					background-color: #909399;
				}
			}
		}

		.h_menu {
			background-color: #fff;

			.menu {
				margin: 0 auto;
				padding-top: 16px;
				display: flex;
				align-items: center;

				.logo_img {
					width: 160px;
					height: 40px;
					margin-right: 80px;
					cursor: pointer;

					img {
						// width: 100%;
						height: 100%;
					}
				}

				.m_item {
					width: 75%;

					ul {
						display: flex;
						justify-content: space-between;

						li {
							white-space: nowrap;

							.icon-arrow-down {
								margin-left: 2px;
								font-size: 18px;
							}

							cursor: pointer;
						}

						li:hover {
							color: #31B266;
						}

						li:last-of-type {
							margin-right: 0;
						}

						.li_active {
							color: #31B266;
						}
					}
				}
			}

		}

		.line {
			width: 100%;
			height: 8px;
			background-color: #31B266;
			margin-top: 16px;
		}

		.children_menu {
			width: 100%;
			background-color: #F8F8F8;
			height: 0;
			line-height: 64px;
			opacity: 0;
			transition: all .5s ease;

			.c_box {
				display: flex;
				// flex-direction: row-reverse;

				ul {
					// width: 75%;
					margin-left: 240px;
					display: flex;

					li {
						font-size: 14px;
						margin-right: 40px;
						cursor: pointer;

						span {
							white-space: nowrap;
						}
					}

					li:last-of-type {
						margin-right: 0;
					}

					li:hover {
						color: #31B266;
					}

					.li_active {
						color: #31B266;
					}
				}
			}


		}

		.show {
			height: 64px;
			line-height: 64px;
			opacity: 1;
			transition: all .5s ease;
		}

		.phone {
			display: none;

			.content {
				display: flex;
				align-items: center;
				height: 50px;
				padding: 0px 20px;
				justify-content: space-between;

				.logo {
					img {
						// width: 160px;
						height: 30px;
						width: auto;
					}
				}

				.icon-navlist {
					color: #31B266;
					font-size: 20px;
					font-weight: bold;
				}
			}

			.el-collapse {}
		}

		.menu_mask {
			// display: none;
			overflow-y: auto;
			background: rgba(0, 0, 0, .5);
			position: fixed;
			top: 86px;
			right: 0;
			bottom: 0;
			left: 0;
		}
	}

	.icon_flag {
		width: 22px;
		height: 14px;
	}

	.flag_name {
		font-size: 12px;
		margin-left: 8px;
	}

	.icon_flag,
	.flag_name {
		vertical-align: middle;
	}

	@media screen and (min-width:768px) {
		.header {
			.menu_mask {
				display: none;
			}
		}
	}

	@media screen and (max-width:768px) {
		.header {

			.h_menu,
			.line,
			.children_menu {
				display: none;
			}

			.text {
				display: none;
			}

			.phone {
				display: block;

				.el-collapse {}
			}

			.menu_mask {
				.menu_ul {
					background-color: #fff;
					padding: 0 25px;

					.menu_li {
						border-bottom: 1px solid #F2F3F5;

						.li_con {
							display: flex;
							justify-content: space-between;
							padding: 15px 0;

							.icon_box {
								display: flex;
								width: 50px;
								height: 100%;
								align-items: center;
								justify-content: end;
							}

							.menu_icon {
								font-size: 20px;
							}

							.placeholder {
								flex-grow: 1;
							}
						}

						.child_ul {
							.child_li {
								display: flex;
								justify-content: space-between;
								padding: 10px 5px;

								.child_li_child {
									font-size: 14px;
								}

								.child_icon {
									width: 50px;
									display: flex;
									align-items: center;
									justify-content: end;
								}
							}
						}
					}
				}

				.el-collapse {
					/deep/.el-collapse-item__header {
						padding: 0 20px;
					}

					/deep/.el-collapse-item__content {
						padding: 0 25px;

						div {
							line-height: 40px;
							display: flex;
							align-items: center;
							justify-content: space-between;
						}
					}
				}
			}
		}
	}
</style>
